module.exports = __webpack_public_path__ + "img/album-mobile.afa438ba.png";